<template>
  <header class="header" :class="{ 'header--scrolled': scrolled }">
    <div class="container header__container">
      <a
        @click.prevent="getCall({ type: 'sale', form: 'header' })"
        class="header__avtomir avtomir"
        href="#"
      >
        <img
          src="../images/logo/logo_avtomir-new.svg"
          alt="Automir"
          class="avtomir__logo"
        />
        <h2 class="avtomir__title">Официальный дилер</h2>
      </a>

      <div class="header__address">
        {{ CONSTANTS.address }}<br/>
        {{ CONSTANTS.worktime }}
      </div>

      <a class="header__phone" :href="`tel:${CONSTANTS.phone_raw}`">
        {{ CONSTANTS.phone }}
      </a>

      <button
        @click="getCall({ type: 'sale', form: 'header' })"
        class="button header__button button_theme_primary"
      >
        Заказать звонок
      </button>

      <a
        @click.prevent="getCall({ type: 'sale', form: 'header' })"
        class="header__logo logo"
        href="#"
      >
        <img
          src="../images/logo/logo.png"
          alt="GEELY Автомир Химки"
          class="logo__img"
        />
      </a>
    </div>

    <div class="header__btns--mob container">
      <a class="header__phone--mob" :href="`tel:${CONSTANTS.phone_raw}`">
        {{ CONSTANTS.phone }}
      </a>

      <button
        @click="getCall({ type: 'sale', form: 'header' })"
        class="button header__button--mob button_theme_primary"
      >
        Заказать звонок
      </button>
    </div>

    <nav class="header__models container">
      <a
          v-for="model in models" :key="model.id"
          :href="model.id"
          class="header__models-item"
      >
        {{ model.name }}
      </a>
    </nav>
  </header>
</template>

<script>
import Mixin from "../common/mixin";
import CARS from "../common/cars-info";
import { ref } from "vue";

export default {
  name: "block-header",
  mixins: [Mixin],
  data() {
    const scrolled = ref(false);

    window.addEventListener("scroll", () => {
      scrolled.value = window.scrollY > 80;
    });

    return {
      scrolled,
    }
  },
  methods: {
    scrollTo(target) {
      document.querySelector(target).scrollIntoView({block: "center", behavior: "smooth"});
    }
  },
  computed: {
    models(){
      return CARS.map(item => {
        // Список моделей
        let name = item.name.replace('GEELY ', '')
        // const newModels = ['okavango', 'atlas_new'] // добавляем к ним new
        // name += newModels.includes(item.key) ? ' NEW' : ''
        const id = '#' + item.key
        return { name, id }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  //height: calcFontSize(65, 97, 320, 1920);
  background: $white;
  width: 100%;
  padding-top: 10px;
  margin: 0 3px;
  position: relative;
  z-index: 3;
  transition: all 0.3s;

  &__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
  }

  .avtomir {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    cursor: pointer;

    &__logo {
      width: 130px;
      margin-right: 47px;
    }

    &__title {
      color: $grey-white;
      font-size: 12px;
      font-weight: 400;
    }
  }

  &__address,
  &__phone,
  &__worktime {
    color: $dark;
    font-size: calcFontSize(10, 14, 320, 1920);
  }

  &__phone {
    margin-left: auto;
    margin-right: calcFontSize(10, 50, 320, 1920);
    font-size: calcFontSize(12, 22, 320, 1920);
    font-weight: bold;
    &:hover {
      text-decoration: underline;
    }
  }

  &__button {
    width: calcFontSize(120, 187, 320, 1920);
    font-size: calcFontSize(11, 17, 320, 1920);
    height: calcFontSize(30, 44, 320, 1920);
    margin-right: calcFontSize(10, 50, 320, 1920);
  }

  .logo {
    display: flex;
    align-items: center;
    width: calcFontSize(108, 126, 320, 1920);

    &__img {
      width: 100%;
    }
  }

  &__models {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1em;
    flex-wrap: wrap;
    font-size: 16px;
    padding-top: 0.5em;
    padding-bottom: 0.5em;

    &-item {
      transition: 0.3s;

      &:hover {
        color: $blue;
      }
    }
  }

  &__btns--mob {
    display: none;
    transition: all 0.3s;
  }
}

@media (max-width: 1000px) {
  .header {
    &__address {
      display: none;
    }

    &__models {
      justify-content: center;
      font-size: 14px;
      gap: 0;

      &-item {
        margin: 0.2em 0.5em;
      }
    }
  }
}

@media (max-width: 640px) {
  .header {
    &--scrolled {
      position: fixed;
      z-index: 10;
      width: 100%;
      padding-top: 5px;

      .header {
        &__models {
          display: none;
        }

        &__button--mob {
          height: 25px;
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .header {
    margin: unset;

    &__btns--mob {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 5px 10px;
      gap: 5px;
    }

    &__phone--mob {
      font-weight: bold;
      font-size: 16px;
    }

    &__button--mob {
      width: 180px;
      height: 40px;
      font-size: 16px;
    }

    &__container {
      display: flex;
      justify-content: space-around;
    }

    &__phone,
    &__button {
      display: none;
    }

    .avtomir {
      &__title {
        display: none;
      }
    }

    &__models {
      font-size: 11px;
    }
  }
}

@media (max-width: 370px) {
  .header {
    &__container {
      justify-content: space-between;
    }

    &__phone--mob {
      font-size: 14px;
    }

    &__button--mob {
      width: 150px;
      height: 35px;
      font-size: 14px;
    }

    &__models {
      font-size: 9px;
      margin: 0.1em 0.3em;
    }
  }
}
</style>
